import React from 'react'
import {MdSpaceDashboard} from 'react-icons/md'
function Header() {
  return (
    <nav className="navbar navbar-expand-lg">
    <div className="container-fluid">
      <a className="navbar-brand" href="/">
        <img src="assets/Logo.svg" alt="" width={220} />
      </a>
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon" />
      </button>
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
          <li className="nav-item">
            <a className="nav-link active" aria-current="page" href="/">Home</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#about">About</a>
          </li>
          
          <li className="nav-item">
            <a className="nav-link" href="#games">Games</a>
          </li>
   
          <li className="nav-item">
            <a className="nav-link" href="#services">Services</a>
          </li>
          
          <li className="nav-item">
            <a className="nav-link" target="_blank"  rel="noreferrer"  href="https://labs.relymer.com/">Careers</a>
          </li>

          <button className='nav-btn'><MdSpaceDashboard/> Dashboard</button>
        </ul>

      </div>
    </div>
  </nav>
  )
}

export default Header